<template>
  <div>
    <ConfirmationBar
      :showSavebar="showSavebar"
      @confirm="submitForm"
      @cancel="cancel"
    />
    <ConfirmationBar
      :showSavebar="deleteNotification"
      :deleteAction="true"
      @confirm="deleteNotificationAction"
      @cancel="cancelDelete"
    />
    <div class="full-page-width relative locations p-b-40">
      <div class="row">
        <div class="col-xs-8">
          <div class="flex-center m-b-40">
            <div class="flex-center">
              <Btn
                @click.native="routeIt"
                class="light bordered empty d-inline-block m-r-15 fix-40"
                :icon="{
                  name: 'arrowLeftBig',
                  size: '20',
                }" />
              <p class="user-name">{{ `${headText}` }}</p>
            </div>
          </div>
          <div class="row m-b-40">
            <div class="col-xs-6">
              <div class="button-bar shadowed"
                :class="isEdit ? 'active brand' : ''"
                @click="Editor">
                <Icon
                  class="m-r-20"
                  name="code"
                  :circle="true"
                  size="24"/>
                <div class="text-box">
                  <span class="main-text">{{ $t('editor') }}</span>
                </div>
              </div>
            </div>
            <div class="col-xs-6">
              <div
                class="button-bar shadowed"
                :class="!isEdit ? 'active brand' : ''"
                @click="Preview">
                <Icon
                  class="m-r-20"
                  name="preview"
                  :circle="true"
                  size="24"/>
                <div class="text-box">
                  <span class="main-text">{{ $t('preview') }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row" v-show="isEdit">
            <div class="col-xs-12">
              <div class="card">
                <InputText
                  class="m-b-30"
                  :label="$t('subject')"
                  v-model="form.subject" />
                <textarea ref="notificationContent" class="editor-box" v-model="form.message"/>
              </div>
            </div>
          </div>
          <div class="row" v-show="!isEdit">
            <div class="col-xs-12">
              <div class="card" ref="renderedNotificationContent"></div>
            </div>
          </div>
        </div>
        <div class="col-xs-4">
          <h2 class="page-title heighted">{{ $t('customization')}}</h2>
          <div class="card m-b-40">
            <InputSelect v-if="get_user.is_admin"
              class="m-b-30"
              :multiSelect=true
              :preselected="form.accessible_for_subaccounts"
              :label="$t('accessible_for_accounts')"
              @change="selectAccessibleSubaccount"
              :options="getAllowedSubaccounts" />
            <div class="toggle-card m-b-30">
              <div>
                <span class="title">{{ $t('enabled') }}</span>
                <span class="additional-info">{{ $t('show_is_message_enabled')}}</span>
              </div>
              <Toggle id="disableMessage" v-model="form.is_enabled" />
            </div>
            <div class="toggle-card">
              <div>
                <span class="title">{{ $t('set_as_default') }}</span>
                <span class="additional-info">{{ $t('set_this_message_as_default') }}</span>
              </div>
              <Toggle id="setAsDefault" v-model="form.is_default" />
            </div>
            <div class="separator medium"></div>
            <CountrySelect
              :multiSelect="true"
              :preselected="countries"
              @change="selectCountries"
              class="m-b-30"
              :label="$t('select_country')" />
            <InputSelect
              :label="$t('SMTP')"
              v-model="form.smtp_id_and_type"
              class="m-b-30"
              :options="get_all_smtps_options" />
            <InputText
              class="m-b-30"
              :label="$t('from_email')"
              v-model="form.from_email" />
            <InputText
              :label="$t('from_name')"
              v-model="form.from_name" />
            <div class="separator medium"></div>
            <div class="toggle-card">
              <div>
                <span class="title">{{ $t('delete')}}</span>
                <span class="additional-info">{{ $t('delete_this_notification') }}</span>
              </div>
              <Toggle color="red" id="deleteNotification" v-model="deleteNotification" />
            </div>
          </div>
          <InfoTextBox :title="$t('notification_var_title')" :text="$t('notification_var_text')" />
          <div class="card variable-box m-b-40">
            <span v-for="(item, index) in variables[notificationType]" :key="`variable-${index}`">
              {{ item }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import {mapGetters} from 'vuex';
import UserCard from '@/components/global/userCard';
import InputText from '@/components/elements/inputs/text.vue';
import Btn from '@/components/elements/buttons';
import Toggle from '@/components/elements/inputs/toggle.vue';
import CountrySelect from '@/components/elements/inputs/countrySelect.vue';
import ConfirmationBar from '@/components/global/confirmationBar';
import InputSelect from '@/components/elements/inputs/select.vue';

import InfoTextBox from '@/components/global/infoTextBox';
import mixin from '@/mixins/mixins.js';

export default {
  name: 'customizeNotification',
  mixins: [mixin],
  components: {
    UserCard,
    InputText,
    Btn,
    Toggle,
    CountrySelect,
    InfoTextBox,
    ConfirmationBar,
    InputSelect
  },
  data() {
    return {
      deleteNotification: false,
      showSavebar: false,
      savebarEnabled: false,
      isVisibleBack: this.$route.params.id,
      isEdit: true,
      userId: '',
      senderName: '',
      senderCompanyName: '',
      notificationType: '',
      notificationBy: '',
      form: {
        accessible_for_subaccounts: [],
        message: '',
        is_enabled: '',
        is_default: '',
        from_email: '',
        from_name: '',
        subject: '',
        countries_json: [],
        notification_type: '',
        smtp_id_and_type: '',
      },
      countries: [],
      variables: [],
      renderedNotificationContent: '',
    };
  },
  computed: {
    ...mapGetters([
      'get_notifications',
      'get_active_notification',
      'get_notification_by_id',
      'get_all_smtps_options',
      'get_user',
      'get_subaccounts'
    ]),
    getAllowedSubaccounts() {
      return this.get_subaccounts.filter((acc) => this.get_user.accessible_subaccounts_array.indexOf(String(acc.id)) > -1).map((acc) => ({text: acc.name, value: String(acc.id),}));
    },
    notificationByText() {
      const notBy = this.notificationBy
      if(parseInt(notBy) === 1 ) return 'E-mail';
      return '';
    },
    notificationTypeText() {
      const notBy = this.notificationType
      if(parseInt(notBy) === 1) return this.$t('Shipment notification').toLowerCase();
      if(parseInt(notBy) === 2) return this.$t('waybill notification').toLowerCase();
      if(parseInt(notBy) === 3) return this.$t('delivery notification').toLowerCase();
      if(parseInt(notBy) === 4) return this.$t('deviation notification').toLowerCase();
      if(parseInt(notBy) === 5) return this.$t('status change notification').toLowerCase();
      if(parseInt(notBy) === 6) return this.$t('return waybill notification').toLowerCase();
      return '';
    },
    headText() {
      let senderName = this.senderCompanyName ? this.senderCompanyName : this.senderName;
      senderName = senderName ? `${this.$t('for')} ${senderName}` : '';

      return `${this.notificationByText + ' ' + this.notificationTypeText + ' ' + senderName}`;
    },
  },
  created() {
    this.$store.dispatch('GET_NOTIFICATION', this.$route.params.id).then((res) => {
      this.form.accessible_for_subaccounts = res.items.accessible_for_subaccounts
      this.form.message = res.items.message;
      this.form.is_default = res.items.is_default;
      this.form.is_enabled = res.items.is_enabled;
      this.form.subject = res.items.subject;
      this.form.from_email = res.items.from_email;
      this.form.from_name = res.items.from_name;
      this.form.countries_json = res.items.countries_array.map((country) => {
        return {
          country_id: country,
          country_name: this.getCountry(country, 'name'),
        };
      }),
      this.countries = res.items.countries_array || [];
      this.senderName = res.items.sender_name;
      this.senderCompanyName = res.items.sender_company_name;
      this.notificationType = res.items.notification_type
      this.notificationBy = res.items.notification_by;
      this.variables = res.entity.variables;
      this.form.notification_type = res.items.notification_type;
      this.form.smtp_id_and_type = res.items.smtp_id_and_type;
      this.$nextTick(() => {
        this.savebarEnabled = true;
      })
    });

    this.$store.dispatch('GET_ALL_SMTPS');
  },
  methods: {
    selectAccessibleSubaccount(val) {
      if(val.length > 0){
        this.form.accessible_for_subaccounts = val;
      }
    },
    routeIt() {
      this.$router.push('/settings/shipping/notifications');
    },
    submitForm() {
      this.$store.dispatch('EDIT_NOTIFICATION', {
        id: this.$route.params.id,
        form: this.form,
      }).then(() => {
        this.$store.dispatch('GET_NOTIFICATIONS');
        this.showSavebar = false;
      });
    },
    cancel() {
      this.showSavebar = false;
    },
    Preview(){
      this.isEdit = false;
      if(this.$refs.notificationContent != undefined) {
        this.$refs.renderedNotificationContent.innerHTML = this.$refs.notificationContent.value;
      }
    },
    Editor(){
      this.isEdit = true;
    },
    selectCountries(val) {
      this.countries = val;
      this.form.countries_json = val.map((country) => {
        return {
          country_id: country,
          country_name: this.getCountry(country, 'name'),
        };
      });
    },
    deleteNotificationAction() {
      this.$store.dispatch('DELETE_NOTIFICATION', this.$route.params.id).then(() => {
        this.$router.push('/settings/shipping/notifications');
      });
    },
    cancelDelete() {
      this.deleteNotification = false;
    }
  },
  watch: {
    'form': {
      handler(){
        if(this.savebarEnabled){
          this.showSavebar = true;
        }
      },
      deep: true
    },
  },
};
</script>
